// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__GXheB","sendOtp":"AuthorizeToLogin_sendOtp__27c_d"};